import styled from 'styled-components'

export const StyledOrderTags = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`
